var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99934 20.7498C8.19841 20.7508 8.38946 20.6715 8.52934 20.5298L16.5293 12.5298C16.8218 12.237 16.8218 11.7627 16.5293 11.4698L8.52934 3.46985C8.23383 3.19449 7.77333 3.20261 7.48772 3.48823C7.20211 3.77384 7.19398 4.23434 7.46934 4.52985L14.9393 11.9998L7.46934 19.4698C7.17689 19.7627 7.17689 20.237 7.46934 20.5298C7.60922 20.6715 7.80027 20.7508 7.99934 20.7498Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.42b2dcf9917892d5958c5866ca17f456.svg";
export { ForwardRef as ReactComponent };